import app from './Vue/app';
import ImageCard from '@components/ImageCard.vue';
import PopCard from '@components/PopCard.vue';
import ProductCarousel from '@components/home/ProductCarousel.vue';
import BobbleHead from '@components/home/BobbleHead.vue';
import SocialCarousel from '@components/home/SocialCarousel.vue';

app.component('ImageCard', ImageCard);
app.component('PopCard', PopCard);
app.component('ProductCarousel', ProductCarousel);
app.component('BobbleHead', BobbleHead);
app.component('SocialCarousel', SocialCarousel);
